import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Avatar, Box, Card, CardActionArea, CardContent, Typography, Paper } from "@mui/material";
import { useNavigate } from 'react-router-dom';

const Content = styled(CardContent)({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '8px'
});

const OrderCard = (props) => {
  const { order, handleCardClick } = props;
  // navigate('/orders/' + order.id)

  return (
    <Box>
      <Card>
        <CardActionArea onClick={() => handleCardClick()}>
          <Content sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', padding: '8px' }}>
            <Box>
              <Avatar sx={{ border: '1px solid lightgray' }} src={order.provider_business_logo && 'http://localhost:3000' + order.provider_business_logo} />
            </Box>
            <Box flexGrow={1} ml={2} textAlign="left">
              <Typography variant="body1"><b>{order.provider.name} #{order.id}</b></Typography>
              <Typography fontSize={14} color="gray">
                <small>{order.date}</small>
              </Typography>
              <Typography fontSize={14} color="gray">
                <small>Status:
                  {order.status === 'paid' ? ' Esperando entregador' : ''}
                  {order.status === 'failed' ? ' Pagamento falhou' : ''}
                  {order.status === 'shipped' ? ' Entregue' : ''}
                  {order.status === 'rejected' ? ' Cancelado' : ''}
                  {order.status === 'done' ? ' Finalizado' : ''}
                  {order.status === 'accepted' ? ' Esperando entregador' : ''}
                  {order.status === 'courier' ? ' Em entrega' : ''}
                  {order.status === 'open' ? ' Esperando comerciante aceitar' : ''}
                </small>
              </Typography>
            </Box>
            <Box>
              {/* todo: adicionar botão de cancelar */}
              {order.status === 'shipped' && (
                <Paper variant="outlined" color="primary">
                  <Typography variant="body2" color="primary" p={1}>
                    Avaliar Pedido!
                  </Typography>
                </Paper>
              )}
            </Box>
          </Content>
        </CardActionArea>
      </Card>
    </Box>
  );
};

export default OrderCard;

